export enum FileExtension {
	CSV = '.csv',
}
